const Styles = {
  maxBodyWidth: '750px',
};

export default Styles;